"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BendingFactor = exports.BendingFactorTexts = exports.BendingFactorUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var BendingFactorUnits;
(function (BendingFactorUnits) {
    BendingFactorUnits["default"] = "x d";
    BendingFactorUnits["xd"] = "x d";
})(BendingFactorUnits = exports.BendingFactorUnits || (exports.BendingFactorUnits = {}));
exports.BendingFactorTexts = {
    [BendingFactorUnits.default]: 'x d',
    [BendingFactorUnits.xd]: 'x d',
};
class BendingFactor extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'BendingFactor';
        this.defaultUnit = 'xd';
        this.unitTexts = exports.BendingFactorTexts;
    }
    static getUnitText(unit) {
        return exports.BendingFactorTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(BendingFactorUnits).includes(q.Unit)) {
            throw new Error(`BendingFactor.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new BendingFactor(q);
    }
    static xd(v) {
        return new BendingFactor(v, BendingFactorUnits.xd);
    }
    set xd(v) {
        this.value = v;
        this.unit = BendingFactorUnits.xd;
    }
    get xd() {
        switch (this.unit) {
            case BendingFactorUnits.xd:
                return this.value;
        }
        throw new Error(`${this.className}.xd: unknown unit ${this.unit}`);
    }
    clone() {
        return BendingFactor.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case BendingFactorUnits.xd:
                return this.xd;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
        throw new Error(`${this.className}.getValue: Unit not supported: ${unit}`);
    }
}
exports.BendingFactor = BendingFactor;
//# sourceMappingURL=BendingFactor.js.map